import LocalInstrumentsDashboard from './LocalInstrumentsDashboard'

export default LocalInstrumentsDashboard
